import { render, staticRenderFns } from "./PropertyInsurancePolicies.vue?vue&type=template&id=3bca91f0&scoped=true"
import script from "./PropertyInsurancePolicies.vue?vue&type=script&lang=js"
export * from "./PropertyInsurancePolicies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bca91f0",
  null
  
)

export default component.exports